import React from 'react';
import { Layout, Row, Col, Typography, Space, Divider, Button } from 'antd';
import {
    MessageOutlined,
    PhoneOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Footer: AntFooter } = Layout;
const { Title, Text } = Typography;

const Footer = () => {
    return (
        <AntFooter
            style={{
                background: '#fff',
                borderTop: '1px solid #f0f0f0',
                padding: '48px 20px'
            }}
        >
            <div className="container">
                <Row gutter={[32, 32]}>
                    {/* О компании */}
                    <Col xs={24} md={8}>
                        <Title level={5} style={{ marginBottom: 16 }}>
                            ChinaTech Store
                        </Title>

                        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                            Прямые поставки техники из Китая. Для ознакомления с товарами
                            используйте каталоги Avito и Ozon, а для заказа напрямую —
                            свяжитесь с нами и получите скидку по промокоду{' '}
                            <Text strong>«САЙТ»</Text>.
                        </Text>

                        <Space wrap>
                            <Button
                                type="text"
                                icon={<MessageOutlined />}
                                href="https://t.me/Abc4free"
                                target="_blank"
                                title="Telegram"
                            >
                                Telegram
                            </Button>

                            <Button
                                type="text"
                                icon={<MessageOutlined />}
                                href="https://max.ru/u/f9LHodD0cOI0DxT8mrCAa3XdiGpEOVZ8KQ2OoBCUoTp8iBBlIN0uOH_MBwU"
                                target="_blank"
                                title="MAX"
                            >
                                MAX
                            </Button>

                            <Button
                                type="text"
                                icon={<PhoneOutlined />}
                                href="tel:+7 3952 996995"
                                title="Позвонить"
                            >
                                Позвонить
                            </Button>
                        </Space>
                    </Col>

                    {/* Каталог */}
                    <Col xs={12} md={4}>
                        <Title level={5} style={{ marginBottom: 16 }}>
                            Каталог
                        </Title>
                        <Space direction="vertical">
                            <a
                                href="https://www.avito.ru/brands/i13534672/all?page_from=from_item_card&iid=3662080701&sellerId=50e11ea716bc29fa1290b9aab13f386e"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block',
                                    marginBottom: 8
                                }}
                            >
                                Avito
                            </a>

                            <a
                                href="https://www.ozon.ru/seller/guru-2253392/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block',
                                    marginBottom: 8
                                }}
                            >
                                Ozon
                            </a>

                            <Link
                                to="/contacts"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block'
                                }}
                            >
                                Контакты
                            </Link>
                        </Space>
                    </Col>

                    {/* Информация */}
                    <Col xs={12} md={4}>
                        <Title level={5} style={{ marginBottom: 16 }}>
                            Информация
                        </Title>
                        <Space direction="vertical">
                            <Link
                                to="/delivery"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block',
                                    marginBottom: 8
                                }}
                            >
                                Доставка
                            </Link>
                            <Link
                                to="/payment"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block',
                                    marginBottom: 8
                                }}
                            >
                                Оплата
                            </Link>
                            <Link
                                to="/warranty"
                                style={{
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    display: 'block'
                                }}
                            >
                                Гарантия
                            </Link>
                        </Space>
                    </Col>

                    {/* Контакты */}
                    <Col xs={24} md={8}>
                        <Title level={5} style={{ marginBottom: 16 }}>
                            Контакты
                        </Title>

                        <Space direction="vertical" size="middle">
                            <Space>
                                <PhoneOutlined style={{ color: '#1890ff' }} />
                                <a
                                    href="tel:+7 3952 996995"
                                    style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                                >
                                    +7 3952 996995
                                </a>
                            </Space>

                            <Space>
                                <MessageOutlined style={{ color: '#1890ff' }} />
                                <a
                                    href="https://t.me/Abc4free"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                                >
                                    Telegram: @Abc4free
                                </a>
                            </Space>

                            <Space>
                                <MessageOutlined style={{ color: '#1890ff' }} />
                                <a
                                    href="https://max.ru/u/f9LHodD0cOI0DxT8mrCAa3XdiGpEOVZ8KQ2OoBCUoTp8iBBlIN0uOH_MBwU"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                                >
                                    MAX
                                </a>
                            </Space>

                            <Space>
                                <Text type="secondary">
                                    ИП ГУРУЛЁВ КОНСТАНТИН ЛЕОНИДОВИЧ
                                </Text>
                            </Space>
                        </Space>
                    </Col>
                </Row>

                <Divider style={{ margin: '32px 0' }} />

                <Row justify="space-between" align="middle" style={{ flexWrap: 'wrap' }}>
                    <Col xs={24} md={12} style={{ marginBottom: 16 }}>
                        <Text type="secondary">
                            © {new Date().getFullYear()} ChinaTech Store. Все права защищены.
                        </Text>
                    </Col>

                    <Col xs={24} md={12} style={{ textAlign: 'right' }}>
                        <Text type="secondary">
                            ИНН: 032618139760 • ОГРН: 324385000087341
                        </Text>
                    </Col>
                </Row>
            </div>
        </AntFooter>
    );
};

export default Footer;